import { ChevronRight } from "lucide-react";
import config from "../../../../utils/config/config";
import { memo } from "react";


const SideBarHeader = ({
  toggleHeaderDropdown,
  showHeaderDropdown,
  selectedDomainDetails,
  isMobile,
  isSideBar }) => {

  const domainName = selectedDomainDetails?.name || "";
  const logoUrl = selectedDomainDetails?.logoUrl;
  const showChevron = !isMobile && !isSideBar;

  const Layers = () => {
    const homeUrl = logoUrl
      ? config.contentURL + logoUrl
      : null;

    return homeUrl ? (
      <img src={homeUrl} className="w-[22px] h-[22px] object-contain" />
    ) : (
      <div className="w-10 h-15 sm:w-8 sm:h-8 animate-pulse bg-gray-300 rounded" />
    );
  };

  return (
    <div className={`border-b-[#282C6C] flex-shrink-0 mb-6 ${!isMobile && !isSideBar ? "border-b" : "border-b-none !mb-0"}`}>
      <div className="py-3">
        {/* Mobile Close Button */}
        <button
          onClick={toggleHeaderDropdown}
          className="w-full flex items-center space-x-3 hover:bg-primary-hover rounded-lg transition-colors duration-200 py-1 px-2"
        >
          <div className="w-[20px] bg-gradient-to-br from-blue-400 to-purple-500 rounded-lg flex items-center justify-center flex-shrink-0">
            <Layers />
          </div>
          <div className="flex-1 text-left min-w-0">
            <h1 className="text-base sm:text-size-14 font-semibold capitalize truncate">
              {domainName}
            </h1>
          </div>
          {showChevron && (
            <ChevronRight
              className={`w-[15px] h-[15px] text-primary-blue transition-transform duration-200 flex-shrink-0 bg-white p-1 rounded-full ${showHeaderDropdown ? "rotate-90" : ""}`}
            />
          )}
        </button>
      </div>
    </div>
  )
};

export default memo(SideBarHeader);